import dayjs from 'dayjs'

export const translations = {
  navigation: {
    month: 'Mês',
    week: 'Semana',
    day: 'Dia',
    today: 'Hoje',
  },
  form: {
    addTitle: 'Adicionar Agendamento',
    editTitle: 'Editar Agendamento',
    confirm: 'Confirmar',
    delete: 'Deletar',
    cancel: 'Cancelar',
  },
  event: {
    title: 'Título',
    start: 'Início',
    end: 'Término',
    allDay: 'Todos os dias',
  },
  validation: {
    required: 'Campo obrigatório',
    invalidEmail: 'Email inválido',
  },
}

export const messages = {
  next: '>',
  previous: '<',
  today: 'Hoje',
  month: 'Mês',
  week: 'Semana',
  day: 'Dia',
  agenda: 'Agenda',
  noEventsInRange: 'Nenhum evento neste intervalo',
  allDay: 'O dia inteiro',
  date: 'Data',
  time: 'Hora',
  event: 'Evento',
}

export const navigation = (nrTempoAgenda: number) => {
  return {
    startHour: 7,
    endHour: 19,
    step: nrTempoAgenda,
    navigation: true,
  }
}

export const formats = {
  dayFormat: 'DD/MM (dddd)',
  dayHeaderFormat: 'DD/MM (dddd)',
  agendaDateFormat: 'DD/MM (dddd)',
  agendaTimeFormat: 'HH:mm',
  agendaHeaderFormat: ({ start, end }: { start: Date; end: Date }) =>
    `${dayjs(start).format('DD/MM')} - ${dayjs(end).format('DD/MM')}`,
  monthHeaderFormat: (
    date: string | number | Date | dayjs.Dayjs | null | undefined,
  ) => dayjs(date).format('MMMM').toUpperCase(),
}
